@if (status.busy) {
<div class="flex flex-justify-center p-t p-b">
    <i class="icon-loading block w-12 center"
       aria-hidden="true"></i>
</div>
}

@for (question of questions; track $index) {
<div class="p-t p-b"
     [ngClass]="question.questionType === 'boolean' ? 'p-b-4-s' : 'p-b-0-s'">
    @switch (question.questionType) {
    @case ('boolean') {
    <div class="flex flex-wrap-s">
        <span class="w-6 w-12-s fw-bold label"
              [ngClass]="{'is-required-mark': question.data.required}">{{question.data.question}}</span>
        <radio-group class="w-6"
                     name="{{'deliveryQuestions' + question.id}}"
                     [(ngModel)]="data[question.id]">
            <radio class="w-6 w-12-s m-t-2-s block"
                   [value]="1"
                   (click)="save()">
                {{'Yes' | translate}}
            </radio>
            <radio class="w-6 w-12-s m-t-2-s block"
                   [value]="0"
                   (click)="save()">
                {{'No' | translate}}
            </radio>
        </radio-group>
    </div>
    @if (question.data.required) {
    <input-wrap>
        <input type="hidden"
               name="{{'deliveryQuestions' + question.id}}"
               required
               [(ngModel)]="data[question.id]">
    </input-wrap>
    }
    }
    @case ('text') {
    <div>
        <span class="fw-bold label"
              [ngClass]="{'is-required-mark' : question.data.required}">{{question.data.question}}</span>
        @if (question.data.required) {
        <input-wrap class="block m-t-2">
            <input class="input"
                   name="{{'deliveryQuestions' + question.id}}"
                   type="text"
                   maxlength="250"
                   required
                   [muiInput]="'Please specify' | translate"
                   [(ngModel)]="data[question.id]"
                   (blur)="save()">
        </input-wrap>
        } @else {
        <input-wrap class="block m-t-2">
            <input class="input"
                   name="{{'deliveryQuestions' + question.id}}"
                   type="text"
                   maxlength="250"
                   [muiInput]="'Please specify' | translate"
                   [(ngModel)]="data[question.id]"
                   (blur)="save()">
        </input-wrap>
        }
    </div>
    }
    @case ('boolean_with_textarea') {
    <div class="fleex flex-wrap-s">
        <span class="w-6 w-12-s fw-bold label"
              [ngClass]="{'is-required-mark': question.data.required}">{{question.data.question}}</span>
        <radio-group class="w-6"
                     name="{{'deliveryQuestions' + question.id}}"
                     [(ngModel)]="$any(data[question.id]).value">
            <radio class="w-6 w-12-s block m-t-2-s"
                   [value]="1"
                   (click)="save()">
                <span>Yes</span>
            </radio>
            <radio class="w-6 w-12-s block m-t-2-s"
                   [value]="0"
                   (click)="$any(data[question.id]).message = undefined; save()">
                <span>No</span>
            </radio>
        </radio-group>
    </div>
    @if (question.data.required) {
    <input-wrap>
        <input type="hidden"
               name="{{'deliveryQuestions' + question.id}}"
               required
               [(ngModel)]="data[question.id]">
    </input-wrap>
    }
    @if ($any(data[question.id]).value) {
    <input-wrap class="w-12 m-t-2">
        <textarea class="textarea"
                  style="resize: vertical; min-height: 100px"
                  name="{{'deliveryQuestions' + question.id + 'message'}}"
                  maxlength="250"
                  required
                  [muiInput]="'Details of parking restrictions'"
                  [(ngModel)]="$any(data[question.id]).message"
                  (blur)="save()"></textarea>
    </input-wrap>
    }
    }
    }
</div>
}